import application from 'application/application';

import template from './reset-password.template.html';

import controller from './reset-password.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.resetPassword', {
				url: '/redefinir-senha/:token',
				views: {
					'root': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Redefinir Senha'
				}
			});

	}]);
